import React, {useState} from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRow from '../elements/InputRow'
import Checkbox from '../elements/Checkbox'
import Error from "../components/Error";

const options = {
    postUrl: '/api/postPaymentMethodDebit',
    success: 'Success! Your payment method has been updated successfully.',
    dontScrollToNav: true
}
const state = {}

const PaymentMethodDebitForm = (props) => {
    const [error, setError] = useState("")
    const removeSpecialChars = event => {
        props.setDynamicValues({
            [event.target.name]: event.target.value.replace(/[^\w]/gi, '')
        })
    }

    const handleSubmit = () => {
        if (props.values.terms) {
            props.handleSubmit()
            setError("")
        } else {
            setError("Please indicate that you have reviewed and agree to the Direct Debit Service Agreement.")
        }
    }

    return (
        <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
            <InputRow
                label='Name of your bank'
                name='bankName'
                placeholder='eg. Westpac'
                value={props.values.bankName}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Branch name'
                name='bankBranch'
                placeholder='eg. North Sydney'
                value={props.values.bankBranch}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Account name'
                name='accountName'
                value={props.values.accountName}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='BSB Number'
                name='bsb'
                value={props.values.bsb}
                errors={props.errors}
                handleChange={props.handleInputChange}
                handleOnBlur={removeSpecialChars}
            />
            <InputRow
                label='Account number'
                name='accountNumber'
                value={props.values.accountNumber}
                errors={props.errors}
                handleChange={props.handleInputChange}
                handleOnBlur={removeSpecialChars}
            />
            <Checkbox
                name='terms'
                value={props.values.terms}
                errors={props.errors}
                handleClick={value => props.setDynamicValues({ terms: value })}
            >
                I have reviewed and agree to the <a href='https://files.exetel.com.au/terms/Direct_Debit_Request_Service_Agreement.pdf' target='_blank'>Direct Debit Service Agreement</a> and authorise payment by Direct Debit.
            </Checkbox>

            {error !== "" && <Error errors={error} />}

            <br />
            {props.children}

            <div className='mt-3 text-center text-md-left'>
                <Button title='Update Payment Method' action={handleSubmit} />
            </div>
        </form>
    )
}

export default FormHOC(PaymentMethodDebitForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/PaymentMethodDebitForm.js